import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import { RouteLocation } from '../../../styled-components/theme-context/cubed-theme-context';

// Config
import { config } from '../configurations/channel-detail-dashboard-comparison';

// Redux
import { useDispatch } from 'react-redux';
import { setDescription, setTitle } from '../../../redux/actions/page-meta';

// Context
import { FilterBarContext } from '../../../filter-bar/context/filter-bar-context';
import { FilterBarContextValues } from '../../../filter-bar/types';
import ChannelDetailDashboardMenuProvider from '../../channel-detail-context/channel-detail-dashboard-menu-context';

// Components
import SectionDashboard from '../../../section-dashboard/components/section-dashboard';

const ChannelDetailDashboardComparison = () => {
    const dispatch = useDispatch();

    const location = useLocation() as RouteLocation;
    location.isSectionDashboard = true;

    const {
        setComparisonFilterStatus,
        setFilterStatus,
        setDatePickerConfig,
        setFilterMetricsOptions,
        setComparisonDatePickerConfig,
    } = useContext(FilterBarContext) as FilterBarContextValues;

    useEffect(() => {
        dispatch(setTitle(config.title));
        dispatch(setDescription(config.description));

        // Filter bar configurations
        setFilterStatus(config.filters.status);
        setComparisonFilterStatus(config.filters.comparisonStatus); // Comparison status
        setFilterMetricsOptions([]); // reset metrics
        setDatePickerConfig(config.filters.datePicker); // reset datepicker
        setComparisonDatePickerConfig(config.filters.comparisonDatePicker); // reset datepicker
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ChannelDetailDashboardMenuProvider>
            <SectionDashboard config={config} />
        </ChannelDetailDashboardMenuProvider>
    );
};

export default ChannelDetailDashboardComparison;
